'use client'
import React from 'react';
import {InputText, InputCounter, InputCheckbox, Tooltip, TimeInput, AddListIng, InputSelectEn, InputRadio} from '../../atoms'
import './Forms.css'  
import { Select, SelectEn} from '../'
import {Loader, ModalInfo} from '../../organisms'
import {timeInputs, complex, process, group, tool, hint, recipeErrors} from '../../../constants/constants' 
import {useDispatch, useSelector} from 'react-redux'
import {useFormValidation} from '../../../utils/Validator.js'
import {AutoComplete, useFormErrors, groupedIngredient} from '../../../utils/utils.js'
import { postRecipe, editRecipe, acceptRecipeUser} from '../../../store/api.js'

export const FormAddRecipe = (props) => {
  const { lib, statusLib } = useSelector(state => state.lib)  
  const { ownerRecipe, statusNewRecipe } = useSelector(state => state.recipes)  
  const { sts, error } = useSelector(state => state.recipes)  
  const {ingredients, statIng} = useSelector(state => state.ingredients)
  const { currentUser, statusUser } = useSelector(state => state.currentUser)
  const [hidden, setHidden] = React.useState(false)
  const [ingredientsData, setIngredientsData] = React.useState([])  
  const [selectedIngredient, setSelectedIngredient] = React.useState({ _id: '', ingredients: '', choisMeasure: '', weight: '', libMeasure: [], group: 'Основное блюдо', thermoself: '' });
  const [filteredIngredients, setFilteredIngredients] = React.useState([]); 
  const [groupedIngredients, setGroupedIngredients] = React.useState([]);
  const [type, setType] = React.useState([]);
  const [typeRef, setTypeRef] = React.useState([]);
  const [selectedStatus, setSelectedStatus] = React.useState('');
  const [tools, setTools] = React.useState( tool); 
  const {errors, validate, setError} = useFormErrors()
  const dispatch = useDispatch()
  const editCard = props.card 
  const [showModal, setShowModal] = React.useState(false); 
  const [textsucces, setTextsucces] = React.useState('');
  const [iconVisual,setIconVisual] = React.useState(false);
  const [times, setTimes] = React.useState(timeInputs);
  const [kitchenware, setКitchenware] = React.useState([]); 
  const [kitchenwareRefs, setКitchenwareRefs] = React.useState([]); 
  const buttonTitle = editCard === undefined ? 'Добавить рецепт' : 'Редактировать рецепт' 
  let saves = JSON.parse(localStorage.getItem('saves')); // Соранение рецепта в браузере
  const [description, setDescription] = React.useState([{ step: 1, img: '', text: '' }]) 
  const options = [
    { value: 'private', label: 'Сделать приватным' },
    { value: 'active', label: 'Сделать активным' },  
  ];
  const { 
    values, 
    handleChange,
    setValues,
    resetForm,
    nameError, 
    setNameError,
    setCategoryError,
    сategoryError,
    complexError,
    setComplexError,
    imageError, 
    setImageError
  } = useFormValidation({
    name: '',
    category: '',
    servings: 1,
    complex: '',
    feast: false,
    daily: false,
    times: [],
    image: [],
    link: '',
    advice: '',
    metaDesc: '',
    status: false
  });
  
  const disabledIng = !selectedIngredient.group || !selectedIngredient.thermoself || !selectedIngredient.ingredients 
  || !selectedIngredient.choisMeasure || !selectedIngredient.weight || errors.ingredient || errors.weight
  const typeError = typeRef.length === 0
  const timeError = times.find(t=> t.timeKey === 'basic' && t.time > 0)
  const timeMarkError = times.some(t=> t.timeKey === 'basic' && t.active === true) 
  const formError = !values.name || !values.category || !values.complex || values.image.length === 0 || ingredientsData.length === 0 || description[0].text === '' || typeError || !timeError || !timeMarkError
  const submitDisabled = errors.ingredient || errors.weight || nameError || formError
  
  function FormError() {
    const newErrors = {};
    if(!values.name) {
      setNameError('Поле не может быть пустым')
    } 
    if(!values.category  ) { 
      setCategoryError('Выберите категорию')
    }
    if(!values.complex  ) { 
      setComplexError('Выберите сложность блюда')
    }
    if(values.image.length === 0 ) {  
      setImageError('Загрузите фото готового блюда')
    }
    if (ingredientsData.length === 0) {
      newErrors.ingredients = 'Выберите хотя бы один ингредиент';
      newErrors.weight = 'Добавьте количество';
      newErrors.thermoself = 'Выберите способ обработки';
    }
    if(description[0].text === '' ) { 
      newErrors.step1 = 'Заполните хотя бы 1 шаг приготовления';
    } 
  // Проверка времени
  if (!timeError) {
      newErrors.basic = 'Укажите время';
  } else if(!timeMarkError) { 
    newErrors.basic = 'Это поле обязательное для заполнения';
 } 
  // Проверка типа питания
  if (!typeError) {
      newErrors.type = 'Выберите хотя бы 1 тип питания';
  }
  if (Object.keys(newErrors).length > 0) {
    setError(prevError => ({ ...prevError, ...newErrors }));
  }
  }  
 
 React.useEffect(()=> { 
    if(editCard === undefined && statusLib === 'resolved') {  
      setКitchenware(lib.kitchenware) 
      setType(lib.typeFoods)
    }
  },[statusLib])

  //Начальные значения при редактировании рецепта
  React.useEffect(()=> { 
    if(editCard && statIng === 'resolved') {    
      //преобразуем старые описания в новые
      const stepsArray = editCard?.description &&   typeof editCard.description === 'object' && Object.keys(editCard.description).length > 0 && Object.entries(editCard.description).map(([key, value], index) => ({
        img: '',  
        step: index+1,
        text: value
      })); 
      //добавляем в старую структуру ингредиентов, группировку
      const ingredientsData = editCard.ingredients.map(ingredient => {
        // Проверяем, есть ли у ингредиента поле group
        if (!ingredient.group) {
            // Если нет, добавляем стандартное значение
            return {
                ...ingredient,
                group: 'Основное блюдо'
            };
        }
        // Если group уже есть, просто возвращаем ингредиент без изменений
        return ingredient;
      });
      const newTimes = editCard.times.length === 0 ?  timeInputs.map((c) => c.timeKey === 'basic' ? {...c, time: editCard.time } : c) : editCard.times
      const kitchen = lib.kitchenware.map(item => ({
        ...item,
        boolean: editCard.kitchenware.find(i => i._id === item._id)?.boolean ?? item.boolean
      }));
      setКitchenware(kitchen)
      setIngredientsData(ingredientsData) 
      setTools(editCard.tools.length === 0 ? tool :editCard.tools)
      //setTools(tool)
      setType(editCard.typeOfDiet)
      setTypeRef(editCard.dietTypesRefs)
      setКitchenwareRefs(editCard.kitchenwareRefs)
      setDescription(editCard.desc.length === 0 ? stepsArray : editCard.desc)
      setTimes(newTimes)
      setValues({
        name: editCard.name,
        category: editCard.category,
        servings: editCard.servings,
        complex: editCard.complex,
        feast: editCard.feast,
        daily: editCard.daily, 
        image: editCard.image,
        link: !editCard.link ? '' : editCard.link,
        advice: editCard.advice ? editCard.advice : '',
        metaDesc: editCard.metaDesc || editCard.name, 
        status: editCard.status
      })
    } 
  }, [editCard, statIng])
  
 
  React.useEffect(()=> {
    setGroupedIngredients(groupedIngredient(ingredientsData))
  }, [ingredientsData])  
 
  const handleSubmit  = async (e) => {
    e.preventDefault();
      if(formError) {
          FormError();
      } else {
        const data = dataRecipe() 
          try {
            // Отправка действия и ожидание выполнения
            await  dispatch(postRecipe(data)).unwrap();
            // Если обновление прошло успешно, можно закрыть модал
            props.onClose();
          } catch (error) {
            localStorage.setItem(
              "saves",
              JSON.stringify(data)
            )
          }
      }
  };

  React.useEffect(() => {
    if (sts === 'rejected' && error) {
        setShowModal(true);
        setIconVisual(false);
        setTextsucces(recipeErrors[error] || "Неизвестная ошибка, попробуйте позже, рецепт сохранен в черновиках"); 
    }
  },[sts, error]);
 
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if(formError) {
      FormError();
    } else {
      const data = dataEditRecipe();
      try {
        // Отправка действия и ожидание выполнения
        await dispatch(editRecipe({ data, id: editCard._id })).unwrap();
        // Если обновление прошло успешно, можно закрыть модал
        props.onClose();
      } catch (error) {
        localStorage.setItem(
          "saves",
          JSON.stringify(data)
        )
      }
  }
};
  

  //формирование объекта для добавления на сервер данных
  function dataRecipe() {
    const newArr ={
      name: values.name,
      nameRu: values.name,
      feast: values.feast,
      daily: values.daily,
      description: {step1: '',},
      complex: values.complex,
      desc: description.filter(d => d.text && d.text.trim() !== ''),
      category: values.category,
      image:  values.image,
      ingredients:  ingredientsData,
      servings:  values.servings, 
      time: times[0].time,
      times: times,
      dietTypesRefs: typeRef, 
      typeOfDiet: type, 
      kitchenwareRefs: kitchenwareRefs,
      kitchenware: kitchenware,
      tools: tools ,
      calories: result,  
      advice:  values.advice,
      metaDesc: values.name, 
      link: values.link, 
      status: values.status === 'private' ? 'private' : 'review',
    }  
    return newArr
  }

    //формирование объекта для редактирования рецепта
    function dataEditRecipe() {
      const newArr ={
        name: values.name,
        nameRu: values.name,
        feast: values.feast,
        daily: values.daily,
        dietTypesRefs:  typeRef, 
        typeOfDiet:  type, 
        kitchenwareRefs: kitchenwareRefs,
        kitchenware: kitchenware,
        tools: tools ,
        complex: values.complex,
        ingredients:  ingredientsData,
        servings:  values.servings, 
        image:  values.image,
        category: values.category, 
        advice:  values.advice,
        metaDesc: values.metaDesc, 
        link: values.link,
        desc: description.filter(d => d.text && d.text.trim() !== ''),
        description: editCard.description, 
        calories:  result,   
        time: editCard.time,
        times: times, 
        status: values.status   
      } 
      return newArr
    }
 
  //Расчет калорий и протеинов для рецепта по списку добавленных ингредиентов с учетом потерь после обработки  
  let result = ingredientsData.reduce((acc, v) => {
    const ingredient = ingredients.find(f => f._id === v._id); 
    if (!ingredient) {
        return acc;
    }
    //Поиск выбранной меры
    const measureRatio = ingredient.measure.find(i => i.nameRu === v.choisMeasure);
    if (!measureRatio) {
        return acc;
    } 
    const totalWeights = measureRatio.ratio * v.weight;  //Пересчет количества ингредиента в граммах
    const { protein, fats, carb, calories } = ingredient.calories; // Достали кбжу ингредиента на 100г
    const {purified, cooking, frying } = ingredient // Достали потери продуктов в зависимости от обработки
    const processType = v.thermoself || 'none'; 
    const rateLooses =  processType === 'cooking' ? (1-cooking/100) :  processType === 'frying' ? (1-frying/100) : 1 // Процент потерь
    const lossesWeight = totalWeights*(1- purified / 100) *rateLooses 
    acc.totalMeasure += totalWeights; // Общий вес без учета потерь
    acc.protein += (protein * totalWeights) / 100; //КБЖУ всего блюда на все порции
    acc.fats += (fats * totalWeights) / 100;
    acc.carb += (carb * totalWeights) / 100;
    acc.calories += (calories * totalWeights) / 100;
    acc.totalWeight += lossesWeight  // Общий вес всего рецепта на все порции с учетом потерь обработки
    return acc;
  }, { protein: 0, fats: 0, carb: 0, calories: 0, totalMeasure: 0, totalWeight: 0 });

  

  ////////////////////////////////////////////////////Изменение данных уже в списке добавленных ингредиентов/////////////////////////
  //Реадктирование веса ингредиента в списке
  const handleWeightChange = (id, value, group, index) => { 
     validate(`weight${index}` , value, index)
    setIngredientsData(prev => 
      prev.map((c) => 
        (c._id === id && c.group === group) ? { ...c, weight: value } : c
      )
    );
   };

 //Реадктирование обработки ингредиента в списке
  function handleEditProcess (value, item) {  
    setIngredientsData(prev => 
      prev.map((c) => 
        (c._id === item._id && c.group === item.group) ? { ...c, thermoself: value.nameEn } : c
      )
    ); 
  }

//Удаление ингредиента из добавленного списка
  function handleDelete(id, group) {
    setIngredientsData((cards) => 
      cards.filter((c) => !(c._id === id && c.group === group))
    );
  }

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    validate(name, 3, 0, checked)
    setTimes(prevTimes =>
      prevTimes.map(timeInput =>
        timeInput.timeKey === name ? { ...timeInput, active: checked } : timeInput
      )
    );
  };
  
  const handleTimeChange = (event) => {
    const { name, value } = event.target; 
    validate(name, value, 0, true)
    const numericValue = value === '' ? 0 : parseInt(value);
    setTimes(prevTimes =>
      prevTimes.map(timeInput =>
        timeInput.timeKey === name ? { ...timeInput, time: numericValue } : timeInput
      )
    );
  };

  function handleEditUnit(value, name) {
    setTimes(prevTimes =>
      prevTimes.map(timeInput =>
        timeInput.timeKey === name ? { ...timeInput, unitСhoice: value } : timeInput
      )
    );
  }

// Отмечаем дополнительное время приготовления
/*const handleCheckboxChange = (event) => {
  const { name, checked } = event.target; 
  setCheckboxStates((prev) => ({
    ...prev,
    [name]: checked
  }));
};*/

const handleInputChange = (e) => {
  const {name, value} = e.target;
  setSelectedIngredient(prev => ({ ...prev, ingredients: value }));
  validate(name, value)
  setHidden(true);
  if (value) {
    setFilteredIngredients(filtrSearchArr(ingredients, value));
  } else {
    setFilteredIngredients([]);
    setHidden(false)
  }
};

const handleAutoSelect = (ingredient) => {
  setSelectedIngredient({ 
    _id: ingredient._id, 
    ingredients: `${ingredient.name} ${ingredient.trait}`, 
    libMeasure: ingredient.measure, 
    choisMeasure: '',
    weight: '',
    group: 'Основное блюдо',
    thermoself: ''
  });
  setHidden(false);
};

const handleChanges = (e) => {
  const { name, value } = e.target; 
  validate(name, value)
  setSelectedIngredient(prev => ({ ...prev, [name]: value }));
  if(name === 'weight') {
  if (!isNaN(Number(value)) && Number(value) >= 1 && Number(value) <= 1000) {
    setSelectedIngredient(prev => ({ ...prev, weight: Number(value) }));
  } else if (value === '') {
    // Если поле пустое, разрешаем его очистить
    setSelectedIngredient(prev => ({ ...prev, weight: 0 }));
  }
}
}




const handleAddIngredient = () => {
  if (selectedIngredient._id && selectedIngredient.weight && selectedIngredient.choisMeasure) {
    setIngredientsData([...ingredientsData, { ...selectedIngredient }]);
    setSelectedIngredient({ _id: '', ingredients: '', choisMeasure: '', weight: '', libMeasure: [], group: 'Основное блюдо' , thermoself: ''});
    setFilteredIngredients([]);
  }
};
 

//Добавляем в value время приготовления 
/*const handleTimeChange = (e) => {
  const { name, value } = e.target;
  validate(name, value)
  setValues((prevData) => ({
    ...prevData,
    times: {
      ...prevData.times,   
      [name]: value 
    }
  }));
  
};*/
  
// Изменение количества порций
const handleIncrease = () => {
  setValues((prevData) => ({
    ...prevData,
    servings: prevData.servings +1
  })); 
};

// функция для уменьшения значения
const handleDecrease = () => {
  setValues((prevData) => ({
    ...prevData,
    servings: Math.max(prevData.servings - 1, 1) // Уменьшаем сервировки, но не ниже 1
  })); 
};


 
 

  

   ///////////////////////////////////////ОБРАБОТКА ТИПОВ ПИТАНИЯ, ОБОРУДОВАНИЯ И ИНСТРУМЕНТОВ////////////////////////////////////////////////////
  /*function handleTypeClick(item) {  
    setType(() => type.map((c) => c.nameEn === item.nameEn ? {...c, boolean: !item.boolean } : c));
    validate('type', '') 
  }*/

  const handleTypeClick = (item) => {
    setType(() => type.map((c) => c.nameEn === item.nameEn ? {...c, boolean: !item.boolean } : c));
    setTypeRef(prevSelected => {
      // Проверяем, есть ли уже этот тип в выбранных
      const typeIndex = prevSelected.indexOf(item._id);
      
      if (typeIndex === -1) {
        // Добавляем новый тип
        return [...prevSelected, item._id];
      } else {
        // Удаляем тип
        return prevSelected.filter(id => id !== item._id);
      }
    });
  };

  /*function handleAppliancesClick(item) { 
    setКitchenware(() => kitchenware.map((c) => c.nameEn === item.nameEn ? {...c, boolean: !item.boolean } : c));
  }*/

  const handleAppliancesClick = (item) => {
    setКitchenware(() => kitchenware.map((c) => c.nameEn === item.nameEn ? {...c, boolean: !item.boolean } : c));
    setКitchenwareRefs(prevSelected => {
      // Проверяем, есть ли уже этот тип в выбранных
      const typeIndex = prevSelected.indexOf(item._id);
      
      if (typeIndex === -1) {
        // Добавляем новый тип
        return [...prevSelected, item._id];
      } else {
        // Удаляем тип
        return prevSelected.filter(id => id !== item._id);
      }
    });
  };

  function handleToolsClick(item) { 
    setTools(() => tools.map((c) => c.nameRu === item.nameRu ? {...c, boolean: !item.boolean } : c));
  }

  const handleStatusChange = (event) => {
     setValues((prevData) => ({
      ...prevData,
      status: event.target.value
    })); 
  };
 
   ///////////////////////////////////////ОБРАБОТКА ФОТОГРАФИЙ////////////////////////////////////////////////////
    const handleTextChange = (index, e) => {
      const newText = e.target.value; 
      validate(`step${index+1}`, newText, index)
      setDescription((prev) => {
        const updated = [...prev]; 
        updated[index] = {
          ...updated[index],
          text: newText
      };

      return updated;
      });
  };

  /*const handleFileChange = (index, e) => {
   
    const file = e.target.files[0];
    console.log(file, index)
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setDescription((prev) => {
          const updated = [...prev];
          console.log(updated)
          updated[index].img = reader.result; // Используем индекс для обновления конкретного шага
          return updated;
        });
      };
      reader.readAsDataURL(file); // Преобразуем файл в base64
    }
  };*/

  const handleFileChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setDescription((prev) => {
          // Создаем полностью новый массив с обновленным объектом
          return prev.map((item, i) => {
            if (i === index) {
              // Создаем новый объект для нужного элемента
              return {
                ...item,
                img: reader.result
              };
            }
            return item;
          });
        });
      };
      reader.readAsDataURL(file);
    }
  };

   //Удаление фотографий для шагов
  const handleDeleteImg = (index, e) => { 
    setDescription((prev) => {
          const updated = [...prev];
          updated[index].img = ''; // Используем индекс для обновления конкретного шага
          return updated;
        });
      
  };

  //Удаление фотографий для блюда
  const handleDeleteImages = (image) => { 
    const newFile = values.image.filter(c => c !== image) 
    setValues(prevValues => ({
      ...prevValues,
      image: newFile, // Объединяем предыдущие изображения с новыми
    }));

  };
 

  const handleAddFiles = async (e) => {
    const imgArr = [];
    const filePromises = []; // Массив для хранения промисов
  
    try {
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        const reader = new FileReader();
        
        const filePromise = new Promise((resolve, reject) => {
          reader.onloadend = () => {
            imgArr.push(reader.result); // Добавляем изображение в формате base64 в массив
            resolve();
          };
          reader.onerror = (error) => {
            reject(error);
          };
          reader.readAsDataURL(file); // Преобразуем файл в base64
        });
  
        filePromises.push(filePromise); // Добавляем промис в массив
      }
  
      // Ждем, пока все файлы будут обработаны
      await Promise.all(filePromises);
  
      // Теперь обновим values.images, добавив новыми изображениями в формате base64
      setValues(prevValues => ({
        ...prevValues,
        image: [...prevValues.image, ...imgArr], // Объединяем предыдущие изображения с новыми
      }));
      if(imgArr.length > 0 ) {
        setImageError('')
      }
     
    } catch (err) {
      console.log(err);
    }
  }
 
  //Добавление шага с описанием
  const handleAddStep = () => {
    setDescription((prev) => [
      ...prev,
      { step: prev.length + 1, img: '', text: '' }
    ]);
  }; 
 
  function handlerCloseError() {
    setShowModal(false);
  }
 
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenCat, setIsOpenCat] = React.useState(false);
  const [isOpenProcess, setIsOpenProcess] = React.useState(false);
  const [isOpenMeasure, setIsOpenMeasure] = React.useState(false);
  const [isOpenGroup, setIsOpenGroup] = React.useState(false);

  function handleFocus() {
    setIsOpen(!isOpen)
  } 

  function handleFocusGroup() {
    setIsOpenCat(!isOpenCat)
  } 
  function handleFocusProcess () {
    setIsOpenProcess(!isOpenProcess)
  } 
  function handleFocusCategory() {
    setIsOpenCat(!isOpenCat)
  } 
  function handleFocusMeasure() {
    setIsOpenMeasure(!isOpenMeasure)
  } 
  
  function handleFocusGroup() {
    setIsOpenGroup(!isOpenGroup)
  } 

  const handleAcceptRecipe = () =>  {
    dispatch(acceptRecipeUser(editCard._id ))
  }
  
  return (
    <form onSubmit={editCard === undefined ? handleSubmit : handleEditSubmit} className='form flexColCenter'>
      <h2 className='font32EB color'>{!editCard ? 'ДОБАВИТЬ РЕЦЕПТ' : 'Редактировать рецепт'}</h2>
      <div className='form__content'>
        <fieldset className='form__fieldset fieldset__title'> 
        <div className='form__fieldset_block'>
          <legend className='font20EB color'>Название блюда </legend>
          <label className='form__label form__label_err'>
          <InputText 
            type='text' 
            types='name' 
            title=''
            value={values.name}
            onChange={handleChange}
            placeholder= 'Название блюда'
            name='name' 
            id='name' 
            error={nameError}
          /> 
          </label> 
        </div> 
          {statusLib ==='resolved' && 
        <div className='form__fieldset_block'>
          <legend className='font20EB color'>Категория блюда </legend>
         {/* <label className='form__label form__label_err'> */ } 
            <label className={`font20EB color form__label_complex ${isOpenCat ? 'form__label_complex_open': 'form__label_complex_close'}`}  onClick={handleFocusCategory}> 
            <Select  
              onChange={handleChange}  
              value={values.category}
              lib={lib.dish}
              actions='Выберите категорию блюда'
              name='category'
              id='category'
              title=''
              error={сategoryError}
              />
             {сategoryError && <span className="form__text_error font14Norm">{сategoryError}</span>} 
          </label>
          </div> 
          } 
          <label className='form__label_capacity font20Norm colorGrey'> 
            <span className="form__span_cooking"> </span>
            Количество порций
            <InputCounter handleIncrease={handleIncrease} values={values.servings} handleDecrease={handleDecrease} name='servings' id='servings'/>
          </label>
          <div className='fieldset__course'> 
            <InputCheckbox title='Праздничное блюдо' onChange={handleChange} checked={values.feast} value={values.feast} name='feast' id='feast'/>
            <InputCheckbox title='Повседневное блюдо' onChange={handleChange} checked={values.daily} value={values.daily} name='daily' id='daily'/> 
        </div> 
        <div className='form__fieldset_block form__label_err'>
          <div className='fieldset__course'>  
            <span className="form__span_complex"> </span> 
            <label className={`font20EB color form__label_complex `}  onClick={handleFocus}> 
            <div className={`form__input_select_block ${isOpen ? 'form__label_complex_open': 'form__label_complex_close'}`}  onClick={handleFocus}>
         
              <Select  
              onChange={handleChange}  
              value={values.complex} 
              actions='Сложность блюда'
              name='complex'
              id='complex' 
              lib={complex}
              error={complexError}
              />  
             </div> 
          </label> 
          <Tooltip content={hint.complex} />
          </div> 
          {complexError && <span className="form__text_error font14Norm">{complexError}</span>}
          </div> 
      
        </fieldset> 
                                           {/*Блок со временем приготовления */} 
        <fieldset className='form__fieldset fieldset__time'> 
          <legend className='form__legend font20EB color'>Время приготовления<Tooltip content={hint.times}/></legend>
            {times[0].timeKey !== undefined &&
            times.map((item, index)=> (
              <TimeInput 
        key={index}
        item={item}
        index={index}
        values={{times}} 
        checkboxStates={times.reduce((acc, curr) => ({ ...acc, [curr.timeKey]: curr.active }), {})}
        handleCheckboxChange={handleCheckboxChange}
        handleEditUnit={handleEditUnit}
        handleTimeChange={handleTimeChange}
        error={errors}
      />
            ))
          } 
        </fieldset> 
      </div>
    {/*Блок с добавлением ингредиентов */} 
      <div className='flexColCenter'>
        <fieldset className='form__fieldset fieldset__ingredient'> 
          <legend className='form__legend font20EB color'>Добавить ингредиенты</legend>
          {Object.keys(groupedIngredients).map((group) => (
            <div className='form__data_groupe' key={group}>
              <h3 className='form__group_title font20EB'>{group}</h3>
              {groupedIngredients[group].map((item, index) => (
                <AddListIng 
                  key={index}
                  item={item}
                  index={index} 
                  handleWeightChange={handleWeightChange}
                  handleDelete={handleDelete}
                  onChange={handleEditProcess}
                   error={errors}
                />
              ))}
            </div>
          ))} 
      </fieldset>
        <fieldset className='form__fieldset fieldset__ingredient'>  
          <div className='form__data_add-ingredient'>
            <label className='form__label form__label_ingredient font20EB color'>
              <Tooltip content={hint.ingredient} type='abs'/>
              <input 
                type='text'  
                title=''
                value={selectedIngredient.ingredients || ''}
                onChange={handleInputChange}
                onFocus={props.onFocus} 
                placeholder= 'Начните вводить ингредиент'
                name='ingredients' 
                id='ingredients'  
                autoComplete="off" 
                className={`form__input font20Norm ${errors.ingredients ? 'form__error' : ''}`}
                aria-describedby={`${props.name}-error`} 
              />  
              {errors.ingredients ? (
  <span className="form__text_error font14Norm">
    {errors.ingredients}
  </span>
) : (
  <>
    {filteredIngredients.length > 0 && hidden && (
      <div className={`add-recipe__autocomplete ${hidden ? 'add-recipe_hidden' : ''}`}>
        {filteredIngredients.map((item, index) => (
          <AutoComplete key={index} item={item} onClick={handleAutoSelect} />
        ))}
      </div>
    )}
    
    {filteredIngredients.length === 0 && selectedIngredient.ingredients && (
      <div className={`add-recipe__autocomplete ${hidden ? 'add-recipe_hidden' : ''}`}>
        <p className='add-recipe__autocomplete_err colorRed'>
        <p className='gg-no-dish'></p> 
           <p className=' font20Nprm '>Ингредиент не найден</p> 
        </p>
        
      </div>
    )}
  </>
)}
            </label>
            <label className='form__label_count font20Norm'>
              <input
                type="number"
                id="weight"
                name="weight"
                min="0"
                max='1000'
                value={selectedIngredient.weight || ''}
                placeholder="0"
                onChange={handleChanges}
                className={`form__input_weight font20Norm ${errors.weight ? 'form__input_error' : ''}`}
              />  
              {errors.weight && <span  className="form__text_error font14Norm">{errors.weight}</span>}
            </label>  
            <label className={`font20EB color form__label_measure`}  onClick={handleFocusMeasure}> 
            <div className={`form__input_select_block ${isOpenMeasure ? 'form__label_complex_open': 'form__label_complex_close'}`}  onClick={handleFocusMeasure}> 
          
          <Select  
          onChange={handleChanges}  
          value={selectedIngredient.choisMeasure}
          lib={statIng === 'resolved' ? selectedIngredient.libMeasure : []}
          actions='Мера'
          name='choisMeasure'
          id='choisMeasure'  
        /> 
        </div>
        {errors.choisMeasure && <span  className="form__text_error font14Norm">{errors.choisMeasure}</span>}
        <Tooltip content={hint.measure} type='abs'/>
      </label> 
          <label className={`font20EB color form__label_group`} >   
          <div className={`form__input_select_block ${isOpenGroup ? 'form__label_complex_open': 'form__label_complex_close'}`}  onClick={handleFocusGroup}>
          <Select  
              onChange={handleChanges}  
              value={selectedIngredient.group || ''} 
              actions='Группа'
              name='group'
              id='group' 
              lib={group}
              /> 
              </div>
              <Tooltip content={hint.group} type='abs'/>
              
          </label> 
          <label className={`font20EB color form__label_process`}> 
          <div className={`form__input_select_block ${isOpenProcess ? 'form__label_complex_open': 'form__label_complex_close'}`}  onClick={handleFocusProcess}> 
            <SelectEn  
              onChange={handleChanges}  
              value={selectedIngredient.thermoself || ''} 
              actions='Обработка'
              name='thermoself'
              id='thermoself' 
              lib={process}
              /> 
               </div>
              <Tooltip content={hint.process} type='abs'/>
              {errors.thermoself && <span  className="form__text_error font14Norm">{errors.thermoself}</span>}
          </label>
      
      </div>
      <button 
        disabled = {disabledIng}
        type='button' 
        onClick={handleAddIngredient}  
        className={`buttonGreen p-m-l ${disabledIng ? 'buttonDisabled' : ''}`}
      > Добавить ингредиент</button>
      </fieldset>
      </div>
      <div className="flexColCenter">
        <fieldset className='fieldset__type'>
        <div className='form__block_legend'>
          <legend className='form__legend font20EB color'>Тип питания <Tooltip content={hint.type} /> </legend>
          {errors.type && <span className="form__text_error font14Norm">{errors.type}</span>}
          </div>
          <div className='form__block_type'>
          {   /*statusLib === 'resolved' &&
            type.map((item, index)=> (
              <button type='button' key={index} onClick={()=>handleTypeClick(item)} className={`buttonGrey font20Norm ${item.boolean ? 'fon-colors': ''}`} >{item.nameRu}</button>
            ))  */
           statusLib === 'resolved' &&
            lib.typeFoods.map((item) => (
              <button
                type='button'
                key={item._id}
                onClick={() => handleTypeClick(item)}
                className={`buttonGrey font20Norm ${
                  typeRef.includes(item._id) ? 'fon-colors' : ''
                }`}
              >
                {item.nameRu}
              </button>
            ))}
          
          </div>
        </fieldset>
        <fieldset className='fieldset__type'>
        <div className='form__block_legend'>
          <legend className='form__legend font20EB color'>Оборудование <Tooltip content={hint.appliances} /></legend>
          </div>
          <div className='form__block_type'>
         {/* statusLib === 'resolved' &&
            kitchenware.map((item, index)=> (
              <button type='button' key={index} onClick={()=>handleAppliancesClick(item)} className={`buttonGrey font20Norm ${item.boolean ? 'fon-colors': ''}`} >{item.nameRu}</button>
            )) 
         */ }
          {
            statusLib === 'resolved' &&
            lib.kitchenware.map((item) => (
              <button
                type='button'
                key={item._id}
                onClick={() => handleAppliancesClick(item)}
                className={`buttonGrey font20Norm ${
                  kitchenwareRefs.includes(item._id) ? 'fon-colors' : ''
                }`}
              >
                {item.nameRu}
              </button>
            ))
          }
           </div>
        </fieldset>
        <fieldset className='fieldset__type'>
        <div className='form__block_legend'>
          <legend className='form__legend font20EB color'>Инструменты <Tooltip content={hint.tools} /></legend>
          </div>
          <div className='form__block_type'>
          {statusLib === 'resolved' &&
            tools.map((item, index)=> (
              <button type='button'key={index}  onClick={()=>handleToolsClick(item)} className={`buttonGrey font20Norm ${item.boolean ? 'fon-colors': ''}`} >{item.nameRu}</button>
            )) 
          }
             </div>
        </fieldset>
      </div>
      <div className="flexColCenter form__step_container">
      <legend className='form__legend form__legend_step font20EB color'>Пошаговая инструкция</legend>
      <p className='form__step_text colorGrey font20EB'>Подробная иструкция поможет правильно приготовить ваш рецепт. По желанию загрузите фото каждого шага.</p>
      { description.map((item, index) =>   
        <StepRecipe 
          key={index} 
          item={index+1}
          step={item.step}
          name={`step${index+1}`}
          description={item} 
          onChange={(e) => handleTextChange(index, e)} // Передаем индекс
          handleFileChange={(e) => handleFileChange(index, e)} // Передаем индекс
          handleAddStep={handleAddStep}
          value={item.text}
          handleDeleteImg={(e) => handleDeleteImg(index, e)}
          error={errors}
        />
        )}
         <button type='button' className={`buttonGreen form__button_step `}  onClick={handleAddStep}>Добавить ещё шаг</button>
   
         </div>
        <div className="flexColCenter">
      <fieldset className='flexRowSB'>   
      <div className='form__block_legend'>
      <button type='button' className=' buttonGreen '>
          <input 
            type="file"
            id="addImage"
             name="addImage" 
             onChange={handleAddFiles} 
             multiple="multiple"
            className="form__input_file_all"
          />  
          <span>   Загрузить фото блюда</span>
        </button>  
        {imageError && <span  className="form__text_error font14Norm">{imageError}</span>}
        </div>
      <div>
      <p className="form__title font20EB" >Введите ссылку на рецепт, если автор не вы</p>
        <input 
          type='url' 
          types='author'
          value={values.link}
          onChange={handleChange}
          placeholder= 'Ссылка на рецепт'
          name='link' 
          id='link'  
          className='form__input'
        />
       </div>
      </fieldset>
      <div className='form__image_list flexRowStart'>
        {values.image.length> 0 &&
        values.image.map((i, index) => (
          <div  key={index} className='form__image_block' >
            <img src={i} className='form__images' alt={props.image} />
            <p className="form__step_img_delete gg-delete m-size" onClick={()=> handleDeleteImages(i)}></p>
          </div> 
        ))
        }
      </div>
      </div>
      
      {currentUser.supervisor && 
        <> 
        <fieldset className='flexColStart'>
        <legend className='form__legend_period font20EB color'>Принять рецепт?  </legend> 
            <InputRadio
              options={options}
              selectedValue={values.status}
              onChange={handleStatusChange}
              name='status'
            />
            <button type="button" onClick={handleAcceptRecipe} disabled={values.status !== 'active'} className={`buttonGreen buttonGreen__signin ${values.status !== 'active' ? ('buttonDisabled') : 'section__link'}`} >Приянть и начислить баллы</button>
        </fieldset>
        
        </>
      }
     
      <button type="submit" disabled={submitDisabled}  className={`buttonGreen buttonGreen__signin ${submitDisabled ? ('buttonDisabled') : 'section__link'}`} >
      {sts === 'loading' ?  <Loader type= 'signin' /> : buttonTitle} 
      </button>
      {submitDisabled && <span className="form__text_error font14Norm">Не все обязательные поля заполнены</span>}
      {showModal &&
         <ModalInfo  onClose={handlerCloseError} textError={textsucces} icon={iconVisual} name="modal-info"/>
      }
   
    </form>
  );
};
 
 
export function filtrSearchArr(arr, keyword) {
  const keywordSearch = keyword.toLowerCase();
  return arr.filter(item => item.name.toLowerCase().includes(keywordSearch));
}


const StepRecipe = (props) => {
  const image = props.description.img 
  const disabled = props.value ===''
  const lengthDesc = props.description.text.length 
  const errorValue = props.error[props.name];   
  return (
    <article className='form__step_item'>
      <p className='font20EB colorGrey'>ШАГ №{props.step}</p>
      <label className='form__label'> 
      <div className='file-input-wrapper'> 
  {image === '' ? 
    <>
      <input 
        type="file"
        id="addImage"
        name="addImage" 
        onChange={props.handleFileChange} 
        multiple
        className="form__input_file"
      /> 
      <span className='form__file_visible forn14Norm colorGrey'></span>
    </>
 : <ImageFields image ={image} onClick={props.handleDeleteImg } />
    
  } 
      </div>
        <textarea  
          rows="4"
          cols='50' 
          min="10" 
          max="1000" 
          id={`step${props.step}`}
          name={`step${props.step}`}
          value={props.value}
          onChange={props.onChange}
          placeholder='Введите шаг приготовления' 
          className={`form__input_text-area font20Norm colorGrey ${errorValue ? 'form__input_error' : ''}`} 
        />  
       <span className='form__step_count forn14Norm colorGrey '>{lengthDesc}/1000</span>
        </label>
         <div className='error__block'> {errorValue && <span className="form__text_error font14Norm">{errorValue}</span>}</div>
        </article>
  )
}

 

/*const Tooltip = ({ content, type }) => {
  const [showTooltip, setShowTooltip] = React.useState(false);

  const handleMouseEnter = () => {
      setShowTooltip(true);
  };

  const handleMouseLeave = () => {
      setShowTooltip(false);
  }; 
  return (
      <span
          className={`tooltip-wrapper gg-issue ${type==='abs' ? 'tooltip__abs': ''}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
      > 
          {showTooltip && (
              <div className="tooltip font12Norm">{content}</div>
          )}
      </span>
  );
};*/


  const ImageFields = (props) => {   
    function handleClick() {
      props.onClick(props.image)
    }
  
    return (
      <div>
      <img src={props.image} className={`${props.type === 'image__list' ? 'form__images': 'form__step_img'}`} alt={props.image} />
      <p className="form__step_img_delete gg-delete m-size" onClick={handleClick}></p>
      </div>
    )
  };

